var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 14 14","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M14 1.41L12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7z"}})])};var toString = function () {return "/app/static/svg/icon_close.svg"};module.exports = { render: render, toString: toString };


//////////////////
// WEBPACK FOOTER
// ./static/svg/icon_close.svg
// module id = 900
// module chunks = 11 15 75 79 100 101 114